import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'

const Headersociales = () => {
  return (
      <div className='header__socials'>
        <a href="https://www.linkedin.com/in/walterya%C3%B1ez/" target="_blank" rel="noreferrer"><BsLinkedin/></a>
        <a href="https://github.com/YFWalter" target="_blank" rel="noreferrer"><FaGithub/></a>
      </div>
      )
}

export default Headersociales